import { ButtonType } from '@tableau/widgets';
import * as React from 'react';

import { createCollectionAndShowToasts } from '~src/app/sagas/spaces/content/collections/CollectionSagas';
import { Messages } from '~src/codegen/Localize';
import { ButtonWithSpinner } from '~src/common/react/components/ButtonWithSpinner';

import { Location } from '../../../common/react/Location';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { CreateCollectionClickedSourceOptions,sendCreateCollectionClickedTelemetry } from './CollectionsTelemetry';
import { CollectionsResourceQuery } from './ResourceQuery/CollectionsResourceQuery';

export interface NewCollectionButtonProps {
  readonly urls: SpacesSiteUrls;
  readonly userDisplayName: string;
}

export function NewCollectionButton(props: NewCollectionButtonProps): JSX.Element {
  const [busyCreatingCollection, setBusyCreatingCollection] = React.useState<boolean>(false);

  const createCollection = async () => {
    setBusyCreatingCollection(true);

    const urls = props.urls;
    const resource = new CollectionsResourceQuery();
    const currentUrl = Location.instance.href();
    const userDisplayName = props.userDisplayName;
    await createCollectionAndShowToasts(resource, urls, currentUrl, userDisplayName);
    setBusyCreatingCollection(false);
  };

  return (
    <ButtonWithSpinner
      clicked={() => {
        sendCreateCollectionClickedTelemetry('collections', CreateCollectionClickedSourceOptions.NewCollectionButton);
        createCollection();
      }}
      title={Messages.createCollectionButtonLabel()}
      buttonType={ButtonType.Outline}
      testId={'new-collection-button'}
      disabled={busyCreatingCollection}
      showSpinner={busyCreatingCollection}
    />
  );
}